// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2rmHR","vLegacy":"SelectSecondary_vLegacy__21XjG","error":"SelectSecondary_error__K13ze","disabled":"SelectSecondary_disabled__OkYl3"};